import {HeaderMall9} from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import Button from "../../../../../publicComponent/Button";
import FixedBar from "../../../../../publicComponent/h5/FixedBar";
import {useEffect} from "react";
import {ModalAddressForm} from "../../../../../publicComponent/ModalAddressForm";
import ShippingAddressContext, {ShippingAddressController, useShippingAddressContext} from "../../../../../reducer/moduleReducer/my/shippingAddress";
import Buffer from "../../../../../publicComponent/Buffer";
import {useTranslation} from "react-i18next";

function AddressCard({ data, editAddress, removeAddress, setDefaultAddress }) {
  const { t } = useTranslation();
  return (
    <div className="md:bg-[#fbfbfb] py-[18px] mdmax:py-[10px] px-[26px] mdmax:px-[5px] mdmax:mx-[10px] mb-[10px]">
      <div className="flex justify-between md:items-center">
        <div className="mr-[8px]">
          <h6 className="font-bold mb-[10px] mdmax:mb-[8px] text-[16px]">{data.linkor}</h6>
          <p className="mb-[10px] mdmax:mb-[8px] mdmax:text-[13px]">
            <i className="iconfont icon-mobile mr-[8px] mdmax:hidden"></i>
            {data.mobileNo}
          </p>
          <p className="mdmax:text-[13px]">
            <i className="iconfont icon-location mr-[8px] mdmax:hidden"></i>
            {data.areaName}{data.address}
          </p>
        </div>
        <div className="md:pr-[24px] md:w-[15%] mdmax:mt-[10px]">
          <div className="mb-[5px]">
            <i onClick={() => removeAddress(data.id)}
               className="cursor-pointer iconfont icon-remove text-[22px] mr-[40px] mdmax:mr-[25px]"></i>
            <i onClick={() => editAddress(data)}
               className="cursor-pointer iconfont icon-edit text-[22px]"></i>
          </div>
          <div className="mdmax:hidden">
            {
              data.isDefault === 0
                ? <a className="cursor-pointer"
                     onClick={() => setDefaultAddress(data.id)}>{t('设置为默认地址')}</a>
                : <a className="text-[#FFC75A]">{t('默认地址')}</a>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

function ShippingAddressWrap() {
  const {
    formVisibleHandle,
    closeFormVisible,
    getAddressList,
    removeAddress,
    setDefaultAddress
  } = ShippingAddressController();
  
  const { state } = useShippingAddressContext();
  const { addressQuery, addressList, formVisible, loading } = state;
  const { t } = useTranslation();
  
  useEffect(() => {
    getAddressList();
  }, []);
  
  return (
    <>
      <Navigator.container>
        <h1 className="font-bold py-[30px] text-[24px] pb-[15px] mdmax:hidden">{t('收货地址')}</h1>
        <Button
          onClick={() => formVisibleHandle()}
          className="flex items-center rounded-[5px] py-[12px] px-[26px] border-[#b9b9b9] ml-[26px] bg-white border mdmax:hidden">
          <i className="iconfont icon-plus mr-[5px] mt-[2px]"/>
          <span className="text-[14px]">{t('新增收货地址')}</span>
        </Button>
        <div className="relative">
          <Buffer.Loading loading={loading}/>
          <div className="md:my-[18px] mdmax:divide-y">
            {
              addressList.length > 0
                ? addressList.map((address, i) => (
                  <AddressCard data={address}
                               editAddress={formVisibleHandle}
                               removeAddress={removeAddress}
                               setDefaultAddress={setDefaultAddress}
                               key={i}/>
                ))
                : <Buffer.Empty content={t('暂无相关消息')}/>
            }
          </div>
        </div>
        
        <FixedBar className="text-center">
          <Button onClick={() => formVisibleHandle()}
                  className="rounded-full text-[14px] w-[80%] py-[10px] bg-[#333] text-white">
            {t('新增收货地址')}
          </Button>
        </FixedBar>
      </Navigator.container>
      
      <ModalAddressForm visible={formVisible}
                        formQuery={addressQuery}
                        onClose={closeFormVisible}
                        submitSuccess={() => {
                          closeFormVisible();
                          getAddressList();
                        }}/>
    </>
  );
}

export default function ShippingAddress() {
  
  return (
    <>
      <HeaderMall9/>
      <Navigator title="收货地址" goback/>
      <ShippingAddressContext>
        <ShippingAddressWrap/>
      </ShippingAddressContext>
    </>
  );
}
